import {http} from "@/config/HttpClient";
import {duplicacionStore} from "@/store/duplicacionStore";
import {AxiosResponse} from "axios";
import {Alert} from "@/addons/Alert";
import {recaudacionStore} from "@/store/recaudacionStore";
import QRCode from "qrcode";

export class DuplicacionService {
    private static instance: DuplicacionService;
    public static getInstance(): DuplicacionService {
        return this.instance || (this.instance = new this());
    }

    duplicacionStore = duplicacionStore();
    recaudacionStore = recaudacionStore();

    public async getMotivosDuplicacion() {
        await http.get("getCodigosDuplicacion").subscribe({
            next: (response: AxiosResponse) => {
                this.duplicacionStore.motivos = response.data;
            },
        })
    }

    public async index() {
        this.duplicacionStore.loading = true;
        await http.get("duplicaciones").subscribe({
            next: (response: AxiosResponse) => {
                this.duplicacionStore.duplicaciones = response.data;
                this.duplicacionStore.loading = false;
            },
        })
    }

    public async duplicacionOtroServicio(data: any) {
        return new Promise((resolve, reject) => {

            this.duplicacionStore.loading = true;
            http.post('duplicaciones', data).subscribe({
                next: (response: AxiosResponse) => {
                    this.duplicacionStore.loading = false;
                    Alert.success(response.data.message);
                    this.index();
                    this.duplicacionStore.isNewOtroIngreso = false;

                    this.recaudacionStore.facturaPrintOtroIngreso = response.data.factura;
                    response.data.factura.img = '';
                    QRCode.toDataURL(process.env.VUE_APP_URLSIAT + "&cuf=" + response.data.factura.cabecera.cuf + "&numero=" + response.data.factura.cabecera.nroFactura)
                        .then(url => {
                            this.recaudacionStore.facturaPrintOtroIngreso.img = url;
                            resolve(true);
                        })
                        .catch(err => {
                            console.error(err)
                            resolve(false);
                        })
                },
                error: (error) => {
                    this.duplicacionStore.loading = false;
                    Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                    reject(error);
                }
            })
        });
    }

    public async duplicacionConsumo(data: any) {
        return new Promise((resolve, reject) => {

            this.duplicacionStore.loading = true;
            http.post('duplicacionConsumo', data).subscribe({
                next: (response: AxiosResponse) => {
                    this.duplicacionStore.loading = false;
                    Alert.success(response.data.message);
                    this.index();
                    this.duplicacionStore.isNewConsumoAgua = false;

                    this.recaudacionStore.facturaPrintConsumo = response.data.factura;
                    resolve(response.data);
                },
                error: (error) => {
                    this.duplicacionStore.loading = false;
                    Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                    reject(false);
                }
            })

        });
    }
    public async consultaDuplicacion(data: any) {
        return new Promise((resolve, reject) => {

            this.duplicacionStore.loading = true;
            http.post('consultaDuplicacion', data).subscribe({
                next: (response: AxiosResponse) => {
                    this.duplicacionStore.loading = false;
                    // Alert.success(response.data.message);
                    // this.index();
                    // this.duplicacionStore.isNewConsumoAgua = false;

                    // this.recaudacionStore.facturaPrintConsumo = response.data.factura;
                    resolve(response.data);
                },
                error: (error) => {
                    this.duplicacionStore.loading = false;
                    Alert.error(error.message + '<br/><br/>' + error.response.data.message);
                    reject(false);
                }
            })

        });
    }
}